<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.75 12a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1Z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
</template>